import React, { forwardRef } from "react";
import { Image, Stack } from "react-bootstrap";
import "./GenreTag.scss";

interface GenreTagProps {
  genre: string;
  icon: string;
  fontSize?: string;
  containerClass?: string;
  handleClick?: () => void;
}

const GenreTag = forwardRef<HTMLButtonElement, GenreTagProps>((props, ref) => {
  const { genre, icon, fontSize, containerClass, handleClick } = props;
  return (
    <Stack
      ref={ref}
      as="button"
      direction="horizontal"
      gap={1}
      className={`px-2 py-1 GenreTag ${containerClass}`}
      style={{ fontSize }}
      onClick={handleClick}
    >
      <Image src={icon} className="Icon" width={13} height={13} />
      <p className="Grotesk SpecialFontSettings Genre">{genre.toLowerCase()}</p>
    </Stack>
  );
});

export default GenreTag;
